<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-50 flex justify-center bg-black/60">
      <div class="m-5  w-full md:w-8/12 lg:w-6/12" @click.self="closeDialog(false)">

        <div class="p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">

          <div class="flex flex-col w-full text-black">

            <BlockUI :visible="blocked">

              <div v-if="blocked" class="absolute inset-0 flex items-center justify-center z-50 bg-black/20">
                <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5" fill="transparent"
                  animationDuration=".5s" />
              </div>

              <div class="flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]">
                <div>
                  <font-awesome-icon :icon="['far', 'fa-building']" class="w-6 h-6 text-white" />
                </div>
                <div
                  class="font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis">
                  {{ $t('titulo.editar.datos.empresa') }}
                </div>
              </div>


              <Form :validation-schema="schema" @invalid-submit="onInvalidSubmit" @submit="aplicarCambios">

                <div class="container p-4 text-left max-h-[70vh] overflow-y-auto">

                  <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
                    <div class="w-full px-2 md:w-5/12">
                      <label class="block mb-1">{{ $t('label.nombre.fantasia') }}</label>
                      <Field name="nombreFantasia" v-slot="{ field, errors }" v-model="formData.nombreFantasia">
                        <InputText v-bind="field" type="text" class="input-base"
                          :placeholder="$t('label.nombre.fantasia')"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="nombreFantasia" />
                        </span>
                      </Field>
                    </div>
                    <div class="w-full px-2 md:w-4/12">
                      <label class="block mb-1">{{ $t('label.razon.social') }}</label>
                      <Field name="razonSocial" v-slot="{ field, errors }" v-model="formData.razonSocial">
                        <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.razon.social')"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="razonSocial" />
                        </span>
                      </Field>
                    </div>
                    <div class="w-full px-2 md:w-3/12">
                      <label class="block mb-1">{{ $t('label.cuit') }}</label>
                      <Field name="cuit" v-slot="{ field, errors }" v-model="formData.cuit">
                        <InputText v-bind="field" type="number" class="input-base" :placeholder="$t('label.cuit')"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="cuit" />
                        </span>
                      </Field>
                    </div>
                  </div>

                  <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
                    <div class="w-full px-2 md:w-4/12">
                      <label class="block mb-1">{{ $t('label.pais') }}</label>
                      <Field name="pais" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.pais">
                        <Select @blur="handleBlur" filter @update:model-value="handleChange" :model-value="value"
                          :placeholder="$t('label.pais')" class="input-base" :options="paises" optionLabel="descripcion"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="pais" />
                        </span>
                      </Field>
                    </div>
                    <div class="w-full px-2 md:w-4/12">
                      <label class="block mb-1">Provincia / Estado</label>
                      <Field name="provincia" v-slot="{ field, errors }" v-model="formData.provincia">
                        <InputText v-bind="field" type="text" placeholder="Provincia / Estado" class="input-base"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="provincia" />
                        </span>
                      </Field>
                    </div>
                    <div class="w-full px-2 md:w-4/12">
                      <label class="block mb-1">Localidad / Ciudad</label>
                      <Field name="localidad" v-slot="{ field, errors }" v-model="formData.localidad">
                        <InputText v-bind="field" type="text" placeholder="Localidad / Ciudad" class="input-base"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="localidad" />
                        </span>
                      </Field>
                    </div>
                  </div>

                  <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
                    <div class="w-full px-2 md:w-9/12">
                      <label class="block mb-1">Domicilio</label>
                      <Field name="domicilio" v-slot="{ field, errors }" v-model="formData.domicilio">
                        <InputText v-bind="field" type="text" placeholder="Domicilio" class="input-base"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="domicilio" />
                        </span>
                      </Field>
                    </div>
                    <div class="w-full px-2 md:w-3/12">
                      <label class="block mb-1">C.P.</label>
                      <Field name="codigoPostal" v-slot="{ field, errors }" v-model="formData.codigoPostal">
                        <InputText v-bind="field" type="text" placeholder="Código postal" class="input-base"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="codigoPostal" />
                        </span>
                      </Field>
                    </div>
                  </div>

                  <div
                    class="w-full border border-gray-300 py-2 text-center font-semibold text-gray-500 shadow-md rounded-xl mt-4">
                    Datos comerciales y de contacto
                  </div>

                  <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                    <div class="w-full px-2 md:w-6/12">
                      <label class="block mb-1">Mail comercial</label>
                      <Field name="mailComercial" v-slot="{ field, errors }" v-model="formData.mailComercial">
                        <InputText v-bind="field" type="mail" placeholder="Mail comercial" class="input-base"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="mailComercial" />
                        </span>
                      </Field>
                    </div>
                    <div class="w-full px-2 md:w-1/2">
                      <label class="block mb-1">Teléfono comercial</label>
                      <Field name="telefono" v-slot="{ field, errors }" v-model="formData.telefono">
                        <InputText v-bind="field" type="text" placeholder="Teléfono comercial" class="input-base"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="telefono" />
                        </span>
                      </Field>
                    </div>
                  </div>

                  <div v-if="formData.empresaRedesSociales">
                    <div v-for="empresaRedSocial in formData.empresaRedesSociales" v-bind:key="empresaRedSocial.id"
                      :empresaRedSocial="empresaRedSocial">
                      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                        <div class="w-full px-2">
                          <InputGroup>
                            <InputGroupAddon><font-awesome-icon class="text-black"
                                :icon="empresaRedSocial.redSocial.icono.split(' ')" /></InputGroupAddon>
                            <Field :name="`link-${empresaRedSocial.id}`" v-slot="{ field, errors }"
                              v-model="empresaRedSocial.link">
                              <InputText v-model="empresaRedSocial.link"
                                :placeholder="empresaRedSocial.redSocial.descripcion" class="input-group-base"
                                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                            </Field>
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
                    <div class="w-full px-2 md:w-6/12">
                      <label class="block mb-1">{{ $t('label.pabellon') }}</label>
                      <Field name="pabellon" v-slot="{ field, errors }" v-model="formData.pabellon">
                        <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.pabellon')"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="pabellon" />
                        </span>
                      </Field>
                    </div>
                    <div class="w-full px-2 md:w-6/12">
                      <label class="block mb-1">{{ $t('label.numero.stand') }}</label>
                      <Field name="stand" v-slot="{ field, errors }" v-model="formData.stand">
                        <InputText v-bind="field" type="text" class="input-base" :placeholder="$t('label.numero.stand')"
                          :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                        <span class="text-sm text-red-500 p-error">
                          <ErrorMessage name="stand" />
                        </span>
                      </Field>
                    </div>
                  </div>

                  <div
                    class="w-full border border-gray-300 py-2 text-center font-semibold text-gray-500 shadow-md rounded-xl mt-4">
                    Etiquetas
                  </div>

                  <div class="w-full">
                    <div v-if="formData.tags">
                      <div v-for="tag in formData.tags" v-bind:key="tag.id" :tag="tag">
                        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
                          <div class="w-full px-2">
                            <label class="block mb-1">{{ tag.descripcion }}</label>
                            <Field :name="`tag-${tag.id}`" v-slot="{ errors }">
                              <MultiSelect :model-value="tag.opcionesTagSeleccionados"
                                @update:model-value="val => tag.opcionesTagSeleccionados = val" :options="tag.opciones"
                                optionLabel="descripcion" optionValue="id" filter :placeholder="tag.descripcion"
                                class="input-base"
                                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && tag.opcionesTagSeleccionados?.length > 0, 'input-error': errors.length > 0 }" />
                            </Field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="p-3 flex flex-col md:flex-row gap-2 justify-end w-full bg-gray-100">
                  <a @click="closeDialog(false)"
                    class="cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                    <font-awesome-icon :icon="['fas', 'fa-xmark']" /> {{ $t('boton.cancelar') }}
                  </a>
                  <button type="submit"
                    class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                    <font-awesome-icon :icon="['fas', 'fa-check-double']" /> {{ $t('boton.aplicar.cambios') }}
                  </button>
                </div>

              </Form>
            </BlockUI>


          </div>
        </div>

      </div>
    </div>
  </Teleport>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';

import Swal from 'sweetalert2'
import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';
import Select from 'primevue/select';
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import MultiSelect from 'primevue/multiselect';

import { EMPRESA_MEETINGS, TAG_TIPO_EMPRESA } from 'qreventos-suite/constantes';
import { ConfiguracionMeeting, Empresa, EmpresaRedSocial, EmpresaTag, ModuloEmpresa, Pais, Tag, TagOpcion } from 'qreventos-suite/src/services/suite.interfaces';

import { Acreditado } from "qreventos-suite/services";
import empresaService from 'qreventos-suite/empresas';
import seguridadServices from '@/services/seguridad.services';
import configuracionMeetingService from '@/services/configuracion.merting.services';
import meetingService from 'qreventos-suite/meeting';
import generalService from 'qreventos-suite/generales';


export default defineComponent({
  components: {
    InputText, BlockUI, ProgressSpinner, Select, InputGroup, InputGroupAddon, MultiSelect,
    Field, ErrorMessage, Form
  },
  props: {
    closeFunction: {
      type: Function,
      required: false
    }
  },
  data() {
    return {
      acreditado: undefined as unknown as Acreditado,
      blocked: false,
      empresa: undefined as unknown as Empresa,
      paises: [] as Pais[],
      formData: {
        razonSocial: '',
        nombreFantasia: '',
        cuit: '',
        pais: undefined as unknown as Pais,
        provincia: '',
        localidad: '',
        domicilio: '',
        codigoPostal: '',
        mailComercial: '',
        telefono: '',
        pabellon: '',
        stand: '',
        empresaNueva: false,
        empresaRedesSociales: [] as EmpresaRedSocial[],
        tags: [] as Tag[],
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        razonSocial: yup.string().required(this.$t('errors.razon.social.required')),
        nombreFantasia: yup.string().required(this.$t('errors.nombre.fantasia.required')),
        cuit: yup.string().required(this.$t('errors.cuit.required')).min(6, this.$t('errors.cuit.min')),
        pais: yup.object().required(this.$t('errors.pais.required')),
        mailComercial: yup.string().email(this.$t('errors.correo.invalido')),
      });
    }
  },
  methods: {
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Error", html: this.$t("error.revise") + " " + errores, icon: "error" });
    },
    closeDialog(reloadList: boolean = false) {
      if (this.closeFunction) {
        this.closeFunction(reloadList);
      }
    },
    async fillAcreditado() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
      this.acreditado = await meetingService.findAcreditadoMeetingBy(configuracionMeeting.evento.id, hash);


    },
    async fillEmpresa() {
      const hash: string = seguridadServices.getLocalHash() as string;
      const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;
      this.empresa = await meetingService.findEmpresaAcreditadoBy(configuracionMeeting.evento.id, hash);

      if (this.empresa) {
        this.formData.razonSocial = this.empresa.razonSocial;
        this.formData.cuit = this.empresa.cuit;

        if (this.empresa.pais) {
          this.formData.pais = this.paises.find(pais => pais.id === this.empresa.pais.id) as Pais;
        }

        this.formData.nombreFantasia = this.empresa.nombreFantasia;
        this.formData.stand = this.empresa.stand;
        this.formData.pabellon = this.empresa.pabellon;
        this.formData.provincia = this.empresa.provincia;
        this.formData.localidad = this.empresa.localidad;
        this.formData.domicilio = this.empresa.domicilio;
        this.formData.codigoPostal = this.empresa.codigoPostal;
        this.formData.mailComercial = this.empresa.mailComercial;
        this.formData.telefono = this.empresa.telefono;
        this.formData.empresaRedesSociales = this.empresa.empresaRedesSociales;
        this.formData.empresaNueva = false;

        this.formData.tags = await empresaService.findTagsBy(configuracionMeeting.evento.id, TAG_TIPO_EMPRESA);

        if (this.formData.tags.length > 0) {
          for (let i: number = 0; i < this.formData.tags.length; i++) {
            const tag: Tag = this.formData.tags[i];
            tag.opcionesTagSeleccionados = this.empresa.empresaTags.filter(empresaTag => empresaTag.tag.id === tag.id).map(empresaTag => empresaTag.tagOpcion.id);
          }
        }

      } else {
        this.empresa = {} as Empresa;
        this.formData.empresaNueva = true;
      }
    },
    async aplicarCambios() {
      try {
        this.blocked = true;

        const hash: string = seguridadServices.getLocalHash() as string;
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

        this.empresa.razonSocial = this.formData.razonSocial;
        this.empresa.nombreFantasia = this.formData.nombreFantasia;
        this.empresa.cuit = this.formData.cuit;
        this.empresa.pais = this.formData.pais;
        this.empresa.provincia = this.formData.provincia;
        this.empresa.localidad = this.formData.localidad;
        this.empresa.domicilio = this.formData.domicilio;
        this.empresa.codigoPostal = this.formData.codigoPostal;
        this.empresa.mailComercial = this.formData.mailComercial;
        this.empresa.telefono = this.formData.telefono;
        this.empresa.pabellon = this.formData.pabellon;
        this.empresa.stand = this.formData.stand;
        this.empresa.empresaRedesSociales = this.formData.empresaRedesSociales;
        this.empresa.activo = true;
        this.empresa.modulosEmpresa = [];
        this.empresa.modulosEmpresa.push({ id: EMPRESA_MEETINGS } as ModuloEmpresa);

        this.empresa.empresaTags = [] as EmpresaTag[];
        this.formData.tags.forEach(tag => {
          tag.opcionesTagSeleccionados.forEach(tagOpcionSeleccionada => {
            const empresaTag: EmpresaTag = {} as EmpresaTag;
            empresaTag.tag = tag;
            empresaTag.tagOpcion = { "id": tagOpcionSeleccionada } as TagOpcion;
            this.empresa.empresaTags.push(empresaTag);
          })
        });

        if (this.formData.empresaNueva) {
          await meetingService.saveEmpresa(configuracionMeeting.evento.id, hash, this.empresa);
          const emp: Empresa = await meetingService.findEmpresaAcreditadoBy(configuracionMeeting.evento.id, hash);
          await empresaService.cambiarAdministrador(configuracionMeeting.evento.id, emp.id, this.acreditado.id);
        } else {
          await meetingService.updateEmpresa(configuracionMeeting.evento.id, hash, this.empresa);
        }

        this.closeDialog(true);

      }
      catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: 'Error [' + error + ']', icon: "error" });
      } finally {
        this.blocked = false;
      }
    },
  },
  async mounted() {
    document.body.style.overflow = "hidden";
    try {
      this.blocked = true;

      this.paises = await generalService.findPaisesBy();
      await this.fillAcreditado();
      await this.fillEmpresa();

    } catch (error) {
      this.blocked = false;
      Swal.fire({ title: "Error", text: error + '', icon: "error" });
    } finally {
      this.blocked = false;
    }

  },
  unmounted() {
    document.body.style.overflow = "";
  }
});
</script>